import { RIGHTS } from 'core-uda/Rights'
import { hasYamlRight } from './deprecatedLayers.utils'

export function deprecatedImageryLayer() {
  if (hasYamlRight('imagery')) return {}

  const imageryUrl = RIGHTS('map.layers.imagery.url', '')

  if (!imageryUrl) return {}

  let type = 'tileXYZ',
    url = imageryUrl

  if (imageryUrl.indexOf('tileWMS')) {
    const arr = imageryUrl.split(' ')
    if (arr.length > 1) {
      type = arr[0]
      url = arr[1]
    }
  }
  if (imageryUrl.indexOf('BING') > -1 || imageryUrl.indexOf('sentinel') > -1) {
    type = imageryUrl
  }

  const centerZoomFactor = RIGHTS('map.layers.zoomFactor', 1)

  return {
    type,
    url,
    data: { icon: 'road' },
    maxZoom: 19 * centerZoomFactor,
    zoomFactor: centerZoomFactor === 1 ? 2 : 1.5,
  }
}
